import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core';

const styles = theme => ({
  thead: {
    display: 'table-header-group',
  },
  row: {
    color: 'inherit',
    display: 'table-row',
    height: 56,
    verticalAlign: 'middle',
    outline: 'none',
    borderBottomColor: 'rgb(224, 224, 224)',
    borderBottomStyle: 'solid',
    borderBottomWidth: '1px',
  },
  cell: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
  },
});

const RuleTableHeadersComponent = ({ headers, classes }) => {
  const renderHeaderColumns = () => headers.map(header => (
    <td className={classes.cell} key={header}>
      {header}
    </td>
  ), this);

  return (
    <thead className={classes.thead}>
      <tr className={classes.row}>
        {renderHeaderColumns()}
      </tr>

    </thead>
  );
};

RuleTableHeadersComponent.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(RuleTableHeadersComponent);
